if (typeof window !== 'undefined') {
  window.ZC = window.ZC || {};
  window.ZC.LICENSE = ['49fa0eddcc1e7dfdadf286e363665a21'];
}